module.exports = __webpack_public_path__ + "static/media/dad1.7d635797.png";